export const VOICE_KEYFRAMES = `
  @keyframes voiceWaveBar { from { height: 4px } to { height: 36px } }
  @keyframes voicePulse { 0%, 100% { opacity: 1; transform: scale(1) } 50% { opacity: 0.5; transform: scale(1.5) } }
  @keyframes voiceBlink { 0%, 100% { opacity: 1 } 50% { opacity: 0 } }
  @keyframes voiceFadeInUp { from { opacity: 0; transform: translateY(10px) } to { opacity: 1; transform: translateY(0) } }
  @keyframes voiceSlideFromRight { from { opacity: 0; transform: translateX(16px) } to { opacity: 1; transform: translateX(0) } }
  @keyframes voiceSlideUp { from { transform: translateY(100%) } to { transform: translateY(0) } }
  @keyframes voiceSlideDown { from { transform: translateY(0) } to { transform: translateY(100%) } }
`;
